import React from "react";
import { type IDraggableSidebarItem } from "../../controls";
import { type ArsListingVariable } from "./interface";

/**
 * Custom sidebar item renderer for variables.
 *
 * @param item - Sidebar item
 * @param selected - Whether item is selected
 * @returns Variable display element
 */
export const RenderVariableSidebarItem = (
  item: IDraggableSidebarItem<ArsListingVariable>,
  selected: boolean,
): React.ReactElement => (
  <div
    className={`px-2 py-1 border rounded w-100 ${selected ? "border-primary bg-primary-subtle" : ""}`}
    style={{ cursor: "grab" }}
  >
    <div className="fw-semibold">{item.label}</div>
    <small className="text-muted">
      {item.data.name} ({item.data.dataType})
    </small>
  </div>
);

RenderVariableSidebarItem.displayName = "RenderVariableSidebarItem";
